import * as investorNotificationTypes from './investorNotificationTypes';

const initialState = {
    data: null,
    loading: true,
};

const investorNotificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case investorNotificationTypes.GET_INVESTOR_NOTIFICATION_SUCCESS:
            return {
                ...state,
                data: action.payload,
            };
        case investorNotificationTypes.SET_INVESTOR_NOTIFICATION_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        default:
            return state;
    }
};

export default investorNotificationReducer;
